// @flow

import React from "react";
import { localize } from "redux-i18n";

import { formatDate } from "@transformers/date";
import { ColumnsContainer, GSGrid, View } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { Alert } from "@modules/service/reducer/alerts/types";
import { route } from "@routes/helper";

type Props = $Exact<{
  data: Alert,
  clientId: number,
  ...PropsFromLocalize,
}>;

export class AlertCriteriaView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [this.props.t("ALERTS_ALERT_ID"), this.props.data.id],
              [
                this.props.t("ALERTS_ALERT_TYPE"),
                this.props.t(this.props.data.content.details.alertType),
              ],
              [
                this.props.t("ALERTS_ALERT_TRIGGER_POINT"),
                this.props.t(this.props.data.content.details.triggerMode),
              ],
            ],
          },
          {
            data: [
              [this.props.t("ALERTS_ALERT_NAME"), this.props.data.content.details.name],
              [
                this.props.t("ALERTS_ALERT_ABSENCE_TYPE"),
                this.props.t(this.props.data.content.details.absenceType),
              ],
              [
                this.props.t("ALERTS_ALERT_VALID_FROM"),
                formatDate(this.props.data.content.details.activeFrom),
              ],
            ],
          },
          {
            data: [
              [
                this.props.t("STATUS"),
                this.props.data.content.details.isActive
                  ? this.props.t("ACTIVE")
                  : this.props.t("INACTIVE"),
              ],
              [this.props.t("ALERTS_ALERT_PURPOSE"), this.alertPurposeContent],
              [
                this.props.t("ALERTS_ALERT_END_DATE"),
                formatDate(this.props.data.content.details.activeTo),
              ],
            ],
          },
        ],
      },
    ];
  }

  get alertPurposeContent() {
    const { isActive, alertPurpose, alertConfigurationUsage } = this.props.data.content.details;
    let content = this.props.t(alertPurpose);

    if (
      isActive &&
      (alertPurpose === "MONITORING_PROMPT" || alertPurpose === "WELLBEING_REFERRAL")
    ) {
      content = (
        <View justifyContent="flex-start" direction="row" gap={2}>
          {this.props.t(alertPurpose)}
          {alertConfigurationUsage.isUsed ? (
            <a
              href={route(
                alertPurpose === "MONITORING_PROMPT"
                  ? "ADMINISTRATION_SERVICE_ABSENCE_MONITORING_DETAILS"
                  : "ADMINISTRATION_SERVICE_REFERRAL_DETAILS",
                {
                  clientId: this.props.clientId,
                  processId: alertConfigurationUsage.resourceId,
                },
              )}
              target="_blank"
              rel="noreferrer"
              style={{ height: "20px" }}
            >
              {GSGrid.render.materialIcon("search")}
            </a>
          ) : (
            GSGrid.render.materialIcon(
              "warning",
              "negative",
              this.props.t("ALERTS_PURPOSE_WARNING_TOOLTIP", {
                title: this.props.t(
                  alertPurpose === "MONITORING_PROMPT" ? "ABSENCE_MONITORING" : alertPurpose,
                ),
              }),
            )
          )}
        </View>
      );
    }

    return content;
  }

  render() {
    return <ColumnsContainer rows={this.data} />;
  }
}

export default localize()(AlertCriteriaView);
